import { takeEvery, fork, put, all, call } from 'redux-saga/effects';

import { customHeaders, adminAPIURL } from '../../../../../Containers/Config/index.js';
import { GET_BENEFIT_AND_BENEFIT_GROUP, GET_BENEFIT_AND_BENEFIT_GROUP_SUCCESS, GET_BENEFIT_AND_BENEFIT_GROUP_ERROR } from '../../actions.js';
import apiCall from '../../../apiCall.js';
import cogoToast from 'cogo-toast';

function* getBenefitAndBenefitGroup({ payload }) {
  try {
    const filteredHeaders = { ...customHeaders };
    delete filteredHeaders['X-Requested-By'];

    const response = yield call(apiCall, {
      url: `${adminAPIURL}/v1/client/${payload?.data?.clientId}/projects/${payload?.data?.projectId}/benefits`,
      method: 'GET',
      params: payload?.urlParams,
      headers: {
        // Authorization: Constant?.CLIENT_TOKEN,
        ...filteredHeaders,
        // withCredentials: true
      },
    });

    if (response.status === 200) {
      yield put({
        type: GET_BENEFIT_AND_BENEFIT_GROUP_SUCCESS,
        payload: response?.data,
      });
    } else {
      cogoToast.error(`${response?.response?.data?.message}`);

      yield put({
        type: GET_BENEFIT_AND_BENEFIT_GROUP_ERROR,
        payload: response.data.message,
      });
    }
  } catch (error) {
    yield put({ type: GET_BENEFIT_AND_BENEFIT_GROUP_ERROR, payload: error });
  }
}

export function* watchGetBenefitAndBenefitGroup() {
  yield takeEvery(GET_BENEFIT_AND_BENEFIT_GROUP, getBenefitAndBenefitGroup);
}

function* getBenefitAndBenefitGroupSaga() {
  yield all([fork(watchGetBenefitAndBenefitGroup)]);
}

export default getBenefitAndBenefitGroupSaga;
